import {FC, useEffect, useState} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import {DeactivationReasonSelect} from './DeactivationReasonSelect'

type DeactivateUserModalProps = {
  onSubmit: (deactivationReason: string) => Promise<unknown>
  title: string
  content: string
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const DeactivateUserModal: FC<DeactivateUserModalProps> = ({onSubmit, title, content, setOpen}) => {
  const [isSubmitting, setSubmitting] = useState(false)
  const [deactivationReason, setDeactivationReason] = useState('')

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog mw-500px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='fw-bolder'>{title}</h2>

              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                style={{cursor: 'pointer'}}
                onClick={() => setOpen(false)}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
            </div>
            <div className='modal-body text-center'>
              <div className='text-start'>
                <p>{content}</p>
                <DeactivationReasonSelect
                  value={deactivationReason}
                  onChange={setDeactivationReason}
                  disabled={isSubmitting}
                />
              </div>
              <div className='text-center pt-15'>
                <button
                  className='btn btn-light btn-sm me-3'
                  data-kt-users-modal-action='cancel'
                  onClick={() => setOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type='button'
                  onClick={async () => {
                    setSubmitting(true)
                    await onSubmit(deactivationReason)
                    setSubmitting(false)
                  }}
                  disabled={isSubmitting || !deactivationReason}
                  className='btn btn-primary btn-sm me-3'
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {DeactivateUserModal}
